import { AfterViewInit, computed, ContentChildren, Directive, input, OnDestroy, QueryList, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { ScrollObserverDirective } from '../scroll-observer/scroll-observer.directive';

@Directive({
  selector: '[scrollObserverMediator]',
  exportAs: 'scrollObserverMediator',
  standalone: true
})
export class ScrollObserverMediatorDirective implements AfterViewInit, OnDestroy {
  public scrollObserverId = input.required<string>();

  @ContentChildren(ScrollObserverDirective, { descendants: true })
  private scrollObservers!: QueryList<ScrollObserverDirective>;

  private _scrollObserversSignal = signal<ScrollObserverDirective[] | null>(null);
  private _subscriptions = new Subscription();

  scrollObserver = computed(() => {
    return this._scrollObserversSignal()?.find(scrollObserver => scrollObserver.scrollObserverId() === this.scrollObserverId());
  });

  ngAfterViewInit(): void {
    const scrollObserversChangeSubscription = this.scrollObservers.changes.subscribe(() => {
      this.setScrollObserversSignal();
    });
    this._subscriptions.add(scrollObserversChangeSubscription);

    this.setScrollObserversSignal();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private setScrollObserversSignal() {
    this._scrollObserversSignal.set(this.scrollObservers.toArray());
  }
}
